import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./dialog";
import ActionButton from "./ActionButton";

const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  isLoading = false,
  variant = "default",
  children,
}) => {
  const isDestructive = variant === "destructive";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>

        {children && <div className="mt-2">{children}</div>}

        <div className="mt-4 flex justify-end gap-3">
          <ActionButton
            action="cancel"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
            label={cancelLabel}
          />
          <ActionButton
            action={isDestructive ? "destructive" : "confirm"}
            onClick={onConfirm}
            isLoading={isLoading}
            label={confirmLabel}
            className={
              isDestructive
                ? "bg-red-600 text-white hover:bg-red-700"
                : undefined
            }
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
